(function () {
	'use strict';
    var controllerId = 'accountStakeholderAdd';

    angular.module('app').controller(controllerId, ['$scope', 'common', '$uibModalInstance', '$translate', 'datacontext', 'sectionMenu', 'stakeholderId', accountStakeholderAdd]);

    function accountStakeholderAdd($scope, common, $uibModalInstance, $translate, datacontext, sectionMenu, stakeholderId) {
        var getLogFn = common.logger.getLogFn;
        var logError = getLogFn(controllerId, 'logError');

	    $scope.user = {};
	    $scope.user.Attivato = true;
        $scope.user.StakeholderId = stakeholderId;
        $scope.user.bOperatore = false;
        $scope.user.bAmministratore = false;

        $scope.item = {};
        $scope.item.stato = [{ n: $translate.instant('Attivo'), v: true }, { n: $translate.instant('NonAttivo'), v: false }];
        $scope.item.lingua = [{ name: $translate.instant('Italiano'), value: 'it' }, { name: $translate.instant('Inglese'), value: 'en' }];
        
		$scope.ok = function (isValid) {
			if (isValid) {
                addItem($scope.user).then(function (result) {
                    if (result != '500' && result != '502')
                        $uibModalInstance.close(result);
                });
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};		

		function addItem(item) {
			item.DtAttivazione = new Date();
			return datacontext.stakeholder_addAccount(item).then(function (data) {			    
			    //if (!data || data.Id == null || data.Id == 0) return null;
                if (data == '502') 
                    logError($translate.instant('EmailGiaRegistrata'));
                else if (data == '500')
                    logError($translate.instant('UsernameInUso'));
                else if (data == '400')
                    return null;

			    return data;
			});
		}
	}
})();